import React from 'react';

const IconUpload: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
    <svg xmlns="http://www.w3.org/2000/svg" width="35" height="35" fill="none" viewBox="0 0 35 35" {...props}>
        <path
            style={{stroke: 'var(--secondary-color)'}}
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="2"
            d="M34 23v7.333c0 .973-.386 1.905-1.074 2.593-.688.688-1.62 1.074-2.593 1.074H4.667c-.973 0-1.905-.386-2.593-1.074C1.386 32.238 1 31.306 1 30.333V23M26.665 10.167L17.5 1l-9.167 9.167M17.5 1v22"
        />
    </svg>
);

export default IconUpload;
